import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { General } from "../../interfaces/general";
import { FormGroup } from "@angular/forms";
import { ServiciosGeneralesService } from 'projects/modulo-solicitudes/src/core/servicios/servicios-generales.service';
import { debounceTime } from "rxjs/operators";
import { SolicitudesService } from "../../servicios/solicitudes.service";
import { MatSnackBar } from "@angular/material/snack-bar";

interface iSolicitudProgreso {
	Convocatoria_ID?: number;
	Curp?: string;
}

@Component({
	selector: "app-solicitante",
	templateUrl: "./solicitante.component.html",
	styleUrls: ["./solicitante.component.css"],
})
export class SolicitanteComponent implements OnInit {
	@Input() catalogos: General;
	@Input() estados: Array<any>;
	@Input() DatosSolicitante: FormGroup;
	@Input() esConsulta: boolean = false;
	@Input() esEdicion: boolean = false;
	@Output() onChange = new EventEmitter<object>();
	@Output() CURPValida = new EventEmitter<any>();
	@Output() EmitPapa = new EventEmitter<any>();
	@Output() EmitMama = new EventEmitter<any>();
	@Output() agregarReferencias = new EventEmitter<any>();
	@Output() emitDocumentos = new EventEmitter<any>();
	@Output() resetAll = new EventEmitter<any>();

	loading = false;
	@Input() tieneCURP = false;
	paises: any;
	extranjeroEs = false;
	pais: string;
	municipios: Array<any>;
	esForaneo = false;
	constructor(
		private serviciosGenerales: ServiciosGeneralesService,
		private serviciosSolicitud: SolicitudesService,
		private snackBar: MatSnackBar
	) {}

	ngOnInit(): void {
		this.escucharCURP();
		this.escucharEstatusPapa();
		this.escucharEstatusMama();

		this.DatosSolicitante.get("Personas_Nombre").disable();
		this.DatosSolicitante.get("Personas_ApellidoPaterno").disable();
		this.DatosSolicitante.get("Personas_ApellidoMaterno").disable();
		this.DatosSolicitante.get("Personas_Genero").disable();
		this.DatosSolicitante.get("Personas_EntidadFederativaID").disable();
		this.DatosSolicitante.get("Personas_MunicipioID").disable();
		this.obtenerPaises();
	}

	ngOnChanges(changes) {
		this.listarMunicipios(this.DatosSolicitante.get("Personas_EntidadFederativaID").value)
	}
	escucharCURP() {
		this.DatosSolicitante.get("Personas_CURP")
			.valueChanges.pipe(debounceTime(1500))
			.subscribe((CURP) => {
				console.log(CURP);
				const solicitud: iSolicitudProgreso = {
					Convocatoria_ID: 1001,
					Curp: CURP,
				};

				return CURP.length === 18
					? this.verEstadoSolicitud(solicitud)
					: "";
			});
	}
	escucharEstatusPapa() {
		this.DatosSolicitante.get(
			"Solicitante_SituacionPadreID"
		).valueChanges.subscribe((data) => {
			console.log(data);
			data === 1001 || data === 1003
				? this.EmitPapa.emit(false)
				: this.EmitPapa.emit(true);
		});
	}
	escucharEstatusMama() {
		this.DatosSolicitante.get(
			"Solicitante_SituacionMadreID"
		).valueChanges.subscribe((data) => {
			data === 1001 || data === 1003
				? this.EmitMama.emit(false)
				: this.EmitMama.emit(true);
		});
	}
	obtenerPaises(): void {
		this.serviciosGenerales.listadoPaises().subscribe((res) => {
			this.paises = res;
			const pais = this.paises.filter(
				(pais) => pais.ISO_A3 === this.pais
			);
			this.DatosSolicitante.get("Personas_PaisID").setValue(pais.ID);
		});
	}
	idEstadoMunicipioCURP(estadoID, MunicipioID, flag = true) {
		let idEstadoDB: Array<any> = [];
		if (flag) {
			idEstadoDB = this.estados.filter(
				(estado) => +estado.Codigo === +estadoID
			);
		} else {
			idEstadoDB = this.estados.filter(
				(estado) => +estado.ID === +estadoID
			);
		}
		this.listarMunicipios(idEstadoDB[0].ID);
		if (idEstadoDB.length > 0) {
			this.DatosSolicitante.get("Personas_EntidadFederativaID").setValue(
				idEstadoDB[0].ID
			);
			this.serviciosGenerales
				.listadoMunicipios(idEstadoDB[0].ID)
				.subscribe((res) => {
					this.municipios = res;

					const idMunicipioID = this.municipios.filter(
						(municipio) => +municipio.Codigo === +MunicipioID
					);
					if (
						idMunicipioID[0].ID !== undefined ||
						idMunicipioID.length > 0
					) {
						this.DatosSolicitante.get(
							"Personas_MunicipioID"
						).setValue(idMunicipioID[0].ID);
					}
				});
		}
	}
	verEstadoSolicitud(datos) {
		//this.emitDocumentos.emit();
		if(this.esEdicion) {
			this.serviciosSolicitud.obtenerSolicitudProgreso(datos).subscribe(
				(res) => {
					//this.emitDocumentos.emit();
					if (res.Solicitud_Progreso) {
						this.tieneCURP = true;
						const solicitud = res.Resultado;
						if (
							solicitud.DatosSolicitante
								.Personas_EntidadFederativaID !== 1001
						) {
							this.idEstadoMunicipioCURP(
								solicitud.DatosSolicitante
									.Personas_EntidadFederativaID,
								solicitud.DatosSolicitante.Personas_MunicipioID,
								false
							);
						} else {
							this.extranjeroEs = true;
						}
						if (
							solicitud.DatosSolicitante
								.Personas_EntidadFederativaID === 1012
						) {
							this.esForaneo = false;
						} else {
							this.esForaneo = true;
						}
						// this.DatosSolicitante.reset()
						this.onChange.emit(solicitud);
					}
					if (res.Solicitud_Existe) {
						this.openSnackBar(
							"La solicitud con Esta CURP ya fue insertada",
							"Entendido"
						);
					}
				},
				(res) => {
					console.log(res.error);
					if (
						res.error.Solicitud_Existe === false &&
						res.error.Solicitud_Progreso === false
					) {
						this.obtenerdatosCURP(datos.Curp);
						this.tieneCURP = true;
					}
				},
				() => {}
			);
		}

	}
	listarMunicipios(idEstado: number) {
		this.serviciosGenerales.listadoMunicipios(idEstado).subscribe((res) => {
			this.municipios = res;
		});
	}
	obtenerdatosCURP(CURP: string) {
		this.tieneCURP = false;
		this.resetAll.emit(CURP);
		this.cleanForm();
		this.serviciosGenerales.obtenerDatosCURP(CURP).subscribe((res) => {
			this.tieneCURP = res.Ok;
			if (this.tieneCURP) {
				// this.DatosSolicitante.reset()

				if (res.Data.Country === "MEX") {
					this.mostrarInformacion(res.Data);
					// this.obtenerListaEstadosID()
					this.extranjeroEs = false;
				} else {
					this.pais = res.Data.Country;
					this.extranjeroEs = true;
					this.mostrarInformacion(res.Data);
					this.obtenerPaises();
				}
				this.agregarReferencias.emit();
			} else {
				console.log("Snackbar");
			}
		} , (err) => {
			this.openSnackBar(
				"La CURP registrada no existe",
				"Entendido"
			);
			});
	}
	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 2000,
		});
	}
	mostrarInformacion(persona) {
		console.log(persona);
		if (persona !== undefined) {
			if (persona.Country === "MEX") {
				this.idEstadoMunicipioCURP(+persona.StateId, persona.CityId);
				if (
					+this.DatosSolicitante.get("Personas_EntidadFederativaID")
						.value !== 1012
				) {
					this.esForaneo = true;
				} else {
					this.esForaneo = false;
				}
			} else {
				this.DatosSolicitante.get(
					"Personas_EntidadFederativaID"
				).setValue(1001);
			}
			this.getFecha(persona.BirthDate);
			this.DatosSolicitante.get("Personas_Nombre").setValue(persona.Name);
			this.DatosSolicitante.get("Personas_ApellidoPaterno").setValue(
				persona.Lastname
			);
			this.DatosSolicitante.get("Personas_ApellidoMaterno").setValue(
				persona.Surname
			);
			this.DatosSolicitante.get("Personas_Genero").setValue(
				persona.Genre
			);
			this.CURPValida.emit();
		}
	}

	getFecha(fecha: string) {
		const datos = fecha.split("/");
		const ano = datos[2];
		const mes = datos[1];
		const dia = datos[0];
		const nuevaFecha = `${ano}-${mes}-${dia}T00:00:00`;
		this.DatosSolicitante.get("Personas_FechaNacimiento").setValue(
			nuevaFecha
		);
		const fechaCumpleanos = this.calculateAge(new Date(+ano, +mes, +dia));
		this.DatosSolicitante.get("Personas_Edad").setValue(fechaCumpleanos);
	}

	calculateAge(birthday) {
		const ageDifMs = Date.now() - birthday.getTime();
		const ageDate = new Date(ageDifMs);
		return Math.abs(ageDate.getUTCFullYear() - 1970);
	}
	agregarDiscapacidades(nuevasDiscapacidades) {
		console.log(nuevasDiscapacidades);
		this.DatosSolicitante.get("ListaDiscapacidades").setValue(
			nuevasDiscapacidades
		);
	}
	onRightClick(e) {
		return false;
	}

	cleanForm(){
		//this.ListaDatosAval.get('Direccion').setValue(this.initialDirectionVal);
		//this.ListaDatosAval.get('Empresa_Direccion').setValue(this.initialDirecEmpresaVal);
		this.DatosSolicitante.get('DatosContacto_TelefonoFijo').setValue('');
		this.DatosSolicitante.get('DatosContacto_TelefonoCelular').setValue('');
		this.DatosSolicitante.get('DatosContacto_Correo').setValue('');
		this.DatosSolicitante.get('DatosContacto_Correo_Confimacion').setValue('');
		this.DatosSolicitante.get('AplicaDiscapacidades').setValue(0);
		this.DatosSolicitante.get('ListaDiscapacidades').setValue('');
		this.DatosSolicitante.get('Solicitante_SituacionPadreID').setValue(1002);
		this.DatosSolicitante.get('Solicitante_SituacionMadreID').setValue(1002);
		this.DatosSolicitante.get('Personas_TiempoResidencia').setValue('');
		this.DatosSolicitante.get('Personas_EstadoCivilID').setValue(0);
		this.DatosSolicitante.get('Persona_RFC').setValue('');
		this.DatosSolicitante.get('confirmarCelular').setValue('');
	}
}
